export default __webpack_public_path__ + "b96c282dbf211d29636c5023e1ea43cc.png";